import { Footer } from '../components/ProductTile/components/Footer';

interface BrowsePageOptions {
  browsePageType: string;
  productCategory: string;
  belowRetail: boolean;
  strikethroughAmount?: string;
}

const getFooterStyleByType = (
  typeKey: string | undefined | null,
  browsePageOptions: BrowsePageOptions | undefined = {
    browsePageType: '',
    productCategory: '',
    belowRetail: false,
    strikethroughAmount: '--',
  },
) => {
  switch (typeKey) {
    case 'last_sale':
    case 'release_date':
    case 'average_deadstock_price':
    case 'recent_asks':
    case 'recent_bids':
    case 'volatility':
    case 'price_premium':
      return Footer.Default;
    case 'sales_this_period':
    case 'deadstock_sold':
      return Footer.Box;
    case 'trending_deal':
      return Footer.TrendingDeal;
    case 'your_ask':
    case 'your_bid':
      return Footer.CustomerActivity;
    case 'browse':
      return getFooterStyleByBrowseOptions(browsePageOptions);
    case 'xpress_ship':
      return Footer.XpressShipping;
    default:
      return null;
  }
};

const getFooterStyleByBrowseOptions = ({
  browsePageType,
  productCategory,
  belowRetail,
  strikethroughAmount,
}: BrowsePageOptions) => {
  if (belowRetail) {
    return Footer.Default;
  }

  if (strikethroughAmount) {
    return Footer.TrendingDeal;
  }

  const showNotes =
    browsePageType &&
    !['lowest_ask', 'highest_bid', 'featured'].includes(browsePageType) &&
    (browsePageType !== 'sales_this_period' ||
      (browsePageType === 'sales_this_period' &&
        ['sneakers', 'streetwear'].includes(productCategory.toLowerCase())));

  if (
    browsePageType === 'sales_this_period' ||
    browsePageType === 'deadstock_sold'
  ) {
    return showNotes && Footer.Box;
  }

  return showNotes && Footer.Default;
};

export default getFooterStyleByType;
